export interface DomainConfig {
  themeId: string;
  clerkPublishableKey: string;
  apiBaseUrl: string;
}

/**
 * Domain-to-brand mapping. Key is a hostname substring match.
 *
 * To add a new brand:
 * 1. Add an entry here with the hostname substring and Clerk env var
 * 2. Create theme assets in src/assets/themes/<brand>/
 * 3. Create theme definition in src/lib/themes/themes/<brand>.ts
 * 4. Register theme in src/lib/themes/index.ts
 * 5. Add CSS variable overrides in src/index.css (html.theme-<brand>)
 * 6. Add hostname check to FOUC script in index.html
 * 7. Add VITE_CLERK_PUBLISHABLE_KEY_<BRAND> to all .env files
 */
const DOMAIN_CONFIGS: Record<string, DomainConfig> = {
  aham37: {
    themeId: 'aham37',
    clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY_AHAM37 || '',
    apiBaseUrl: import.meta.env.VITE_APP_BASE_URL_AHAM37 || '',
  },
};

const DEFAULT_CONFIG: DomainConfig = {
  themeId: 'default',
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '',
  apiBaseUrl: import.meta.env.VITE_APP_BASE_URL || '',
};

/**
 * Resolve domain config from the current hostname.
 * Matches against DOMAIN_CONFIGS keys using substring match.
 * Falls back to DEFAULT_CONFIG (Strive).
 *
 * NOTE: The FOUC script in index.html has a mirrored hostname check
 * for applying the theme CSS class before first paint.
 * Keep both in sync when adding new brands.
 */
export function getDomainConfig(): DomainConfig {
  const hostname = window.location.hostname;
  for (const [key, config] of Object.entries(DOMAIN_CONFIGS)) {
    if (hostname.includes(key)) return config;
  }
  return DEFAULT_CONFIG;
}
